<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <image-list
    :entity-name="$t('restaurantImage')"
    :model="model"
    icon="mdi-calendar-today"
  />
</template>

<script>

  import RestaurantImage from '../../../../model/restaurant/RestaurantImage'
  import ImageList from '@/composable/ImageList'

  export default {
    components: {
      ImageList,
    },
    data: function () {
      return ({
        model: RestaurantImage,
      })
    },
  }
</script>
